"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAuditListRequest = exports.isMoreThan12Month = void 0;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const date_fns_1 = require("date-fns");
const isMoreThan12Month = (startDate, endDate) => {
    return (0, date_fns_1.differenceInMonths)(Date.parse(endDate), Date.parse(startDate)) > 11;
};
exports.isMoreThan12Month = isMoreThan12Month;
function mapAuditListRequest(request, additionalFilters) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const listAuditRequest = {
        timestampFrom: 0,
        timestampTo: 0,
        limit: request.limit,
        offset: request.offset,
        orderByTimestampDesc: request.sortColumnDesc,
        auditTags: request.filterData.auditTags,
    };
    if (((_a = request.filterData.dateRange) === null || _a === void 0 ? void 0 : _a.from) && ((_b = request.filterData.dateRange) === null || _b === void 0 ? void 0 : _b.to)) {
        if ((0, exports.isMoreThan12Month)((_c = request.filterData) === null || _c === void 0 ? void 0 : _c.dateRange.from, (_d = request.filterData) === null || _d === void 0 ? void 0 : _d.dateRange.to)) {
            return { request: undefined, error: t('audit.validation.dateRangeTooLong') };
        }
    }
    else {
        return { request: undefined, error: t('audit.validation.dateRangeNotSet') };
    }
    listAuditRequest.timestampFrom = Date.parse((_e = request.filterData) === null || _e === void 0 ? void 0 : _e.dateRange.from);
    listAuditRequest.timestampTo = (0, date_fns_1.add)(Date.parse((_f = request.filterData) === null || _f === void 0 ? void 0 : _f.dateRange.to), { days: 1 }).getTime();
    if ((_g = request.filterData) === null || _g === void 0 ? void 0 : _g.username) {
        listAuditRequest.user = (_h = request.filterData) === null || _h === void 0 ? void 0 : _h.username;
    }
    if (!!((_k = (_j = request.filterData) === null || _j === void 0 ? void 0 : _j.eventType) === null || _k === void 0 ? void 0 : _k.length)) {
        listAuditRequest.eventTypes = (_l = request.filterData) === null || _l === void 0 ? void 0 : _l.eventType;
    }
    else if (additionalFilters === null || additionalFilters === void 0 ? void 0 : additionalFilters.eventTypes) {
        listAuditRequest.eventTypes = additionalFilters === null || additionalFilters === void 0 ? void 0 : additionalFilters.eventTypes;
    }
    if (!!((_m = additionalFilters === null || additionalFilters === void 0 ? void 0 : additionalFilters.entityIds) === null || _m === void 0 ? void 0 : _m.length)) {
        listAuditRequest.entityIds = additionalFilters === null || additionalFilters === void 0 ? void 0 : additionalFilters.entityIds;
    }
    if (!!((_o = additionalFilters === null || additionalFilters === void 0 ? void 0 : additionalFilters.entities) === null || _o === void 0 ? void 0 : _o.length)) {
        listAuditRequest.entities = additionalFilters === null || additionalFilters === void 0 ? void 0 : additionalFilters.entities;
    }
    listAuditRequest.includeRelatedEntities = additionalFilters === null || additionalFilters === void 0 ? void 0 : additionalFilters.includeRelatedEntities;
    return { request: listAuditRequest };
}
exports.mapAuditListRequest = mapAuditListRequest;
